import { FaceLivenessDetector } from "@aws-amplify/ui-react-liveness";
import { LivenessError } from "@aws-amplify/ui-react-liveness/dist/types/components/FaceLivenessDetector/service";
import { useCallback, useEffect, useState } from "react";

import { Spinner } from "@shared/components";
import {
  useFaceLivenessFinish,
  useFaceLivenessStart,
} from "@shared/hooks/query";

import { livenessText } from "./livenessText";

interface FaceLivenessProps {
  onSuccess: () => void;
  onFail: (error?: LivenessError) => void;
}

export const Liveness = ({ onSuccess, onFail }: FaceLivenessProps) => {
  const [sessionId, setSessionId] = useState<string | null>(null);
  const { mutate: livenessStart, isLoading } = useFaceLivenessStart({
    onAlreadyVerified: onSuccess,
  });

  const { mutate: livenessFinish } = useFaceLivenessFinish();

  const startLivenessSession = useCallback(() => {
    livenessStart(undefined, {
      onSuccess: (res) => {
        setSessionId(res.result.sessionId);
      },
    });
  }, [livenessStart]);

  useEffect(() => {
    startLivenessSession();
  }, [startLivenessSession]);

  if (!sessionId || isLoading) {
    return (
      <div className="loading-container">
        <Spinner size="small" />
      </div>
    );
  }

  return (
    <FaceLivenessDetector
      sessionId={sessionId}
      region="ap-northeast-1"
      onAnalysisComplete={async () => {
        if (sessionId) {
          livenessFinish(
            { sessionId },
            {
              onSuccess: (res) => {
                if (res.result.isLive) {
                  onSuccess();
                } else {
                  onFail();
                }
              },
              onError: onFail,
            },
          );
        }
      }}
      onError={onFail}
      displayText={livenessText()}
      onUserCancel={() => {
        onFail();
      }}
    />
  );
};
